module.exports = __webpack_public_path__ + "static/media/n2_rouge.9e8bee6a.svg";